// Capability document route (/$region/assessments/documents/$capabilityDocUid, Confidential): the entry search, level and kind filters in the URL; the screen is CapabilityDocumentPage.
import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { z } from "zod";

import { zCapabilityKind, zCapabilityLevel } from "@/api/__generated__/zod.gen";
import { optionalList, optionalString } from "@/app/search";
import { RestrictedRoute } from "@/app/shell/RouteStates";
import { CapabilityDocumentPage, type DocumentSearch } from "@/features/assessments/CapabilityDocumentPage";

const searchSchema = z.object({
  q: optionalString(),
  level: optionalList(zCapabilityLevel),
  kind: optionalList(zCapabilityKind),
});

export const Route = createFileRoute("/_app/$region/assessments/documents/$capabilityDocUid")({
  validateSearch: searchSchema,
  staticData: { crumb: "Document" },
  component: CapabilityDocumentRoute,
});

function CapabilityDocumentRoute() {
  const { capabilityDocUid } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const onSearchChange = useCallback(
    (next: DocumentSearch) => {
      void navigate({ search: next, replace: true });
    },
    [navigate],
  );
  return (
    <RestrictedRoute level="C" description="Documents to compare are for users with the Confidential role.">
      <CapabilityDocumentPage
        capabilityDocUid={capabilityDocUid}
        search={search}
        onSearchChange={onSearchChange}
      />
    </RestrictedRoute>
  );
}
